<template>
  <div class="content-dashboard">
    <h3>{{ $t("presentation.title") }}</h3>
    <p>{{ $t("presentation.intro") }}</p>

    <div class="row">
      <div class="col-lg-12">
        <div class="progress-box mb-3">
          <div class="progress-box-inner d-flex justify-content-between mb-3">
            <p class="mb-0">{{ $t("presentation.step_products") }}</p>
            <label class="progess-label">{{ $t("presentation.in_progress") }} : {{ progress }}%</label>
          </div>

          <div class="progress">
            <div
              class="progress-bar bg-blue"
              role="progressbar"
              :style="{ width: progress + '%' }"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>

        <div class="progress-box mb-3">
          <div class="progress-box-inner d-flex justify-content-between mb-3">
            <p class="mb-0">{{ $t("presentation.step_promos") }}</p>
            <label class="progess-label">{{ $t("presentation.finished") }}</label>
          </div>

          <div class="progress">
            <div
              class="progress-bar bg-green"
              role="progressbar"
              :style="{ width: '100%' }"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>

        <div class="progress-box mb-3">
          <div class="progress-box-inner d-flex justify-content-between mb-3">
            <p class="mb-0">{{ $t("presentation.step_promos") }}</p>
            <div class="d-flex gap-3">
              <span class="outline-badge">{{ $t("presentation.todo") }}</span>
              <a href="" class="btn btn-orange">{{ $t("presentation.start") }}</a>
            </div>
          </div>

          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              :style="0"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>

        <div class="progress-box mb-3">
          <div class="progress-box-inner d-flex justify-content-between mb-3">
            <p class="mb-0">{{ $t("presentation.step_promos") }}</p>
            <div class="d-flex gap-3">
              <a href="#" class="btn btn-outline">{{ $t("presentation.todo") }}</a>
              <a href="" class="btn btn-orange">{{ $t("presentation.start") }}</a>
            </div>
          </div>

          <div class="progress">
            <div
              class="progress-bar"
              role="progressbar"
              :style="0"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-lg-12">
        <p>{{ $t("presentation.onboarding") }}</p>

        <div class="big-video">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/yZD1wtzBLb0?si=VF_nEy20sZNsPJC-"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-lg-3">
        <div class="small-video">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/yZD1wtzBLb0?si=VF_nEy20sZNsPJC-"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="small-video">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/yZD1wtzBLb0?si=VF_nEy20sZNsPJC-"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="small-video">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/yZD1wtzBLb0?si=VF_nEy20sZNsPJC-"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="small-video">
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/yZD1wtzBLb0?si=VF_nEy20sZNsPJC-"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { ref } from "vue";

  const progress = ref(75);
  export default {
    name: " PresentationView",
    data() {
      return {
        progress,
      };
    },
  };
</script>
